module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-tips.234b413d.jpg";